import React from 'react';
import { Box, TextField, FormControlLabel, Checkbox } from '@mui/material';

type Role = {
  id?: string;
  name: string;
  perms: Record<string, boolean>;
};

interface Props {
  value: Role;
  onChange: (r: Role) => void;
}

export const permKeys = [
  { key: 'groups', label: 'Create,Modify,Delete Group' },
  { key: 'hardware', label: 'Create,Modify,Delete Hardware' },
  { key: 'profiles', label: 'Create,Modify,Delete a Profiles' },
  { key: 'devices', label: 'Create,Modify,Delete a Devices' },
  { key: 'userroles', label: 'Create,Modify,Delete a UserRoles' },
];

export default function RoleForm({ value, onChange }: Props) {
  return (
    <Box sx={{ mt: 1 }}>
      <Box sx={{ mb: 2 }}>
        <Box sx={{ fontWeight: 700, color: '#e0e0e0', mb: 1 }}>Here you can create the Roles information.</Box>
        <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: '320px 1fr' }, alignItems: 'center' }}>
          <Box sx={{ fontWeight: 700, color: '#e0e0e0', alignSelf: 'center' }}>Enter Role Name :</Box>
          <TextField placeholder="Enter Profile Name here" size="small" value={value.name} onChange={(e) => onChange({ ...value, name: e.target.value })} fullWidth />
        </Box>
      </Box>

      <Box sx={{ display: 'grid', gap: 2 }}>
        {permKeys.map((p) => (
          <Box key={p.key} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{ fontWeight: 700, color: '#e0e0e0', width: 280 }}>{p.label}</Box>
            <FormControlLabel control={<Checkbox checked={Boolean(value.perms[p.key])} onChange={() => onChange({ ...value, perms: { ...value.perms, [p.key]: !value.perms[p.key] } })} />} label="" />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
